import { Flex, Result, Typography } from 'antd';

import { Logger } from '@suntex.core/logging';
import { isRouteErrorResponse, useRouteError } from '@suntex.core/nav';
import { SignOutReason } from '@suntex.fim/auth';
import { useAuth } from '@suntex.fim/auth/react';
import { Button } from '@suntex.fim/ui';

const { Paragraph, Text } = Typography;
const logger = Logger.for('ErrorPage');

/**
 * Friendly error page used as `errorElement` on routes.
 * Shows a user-friendly message and logs the real error to the console.
 */
export function ErrorPage() {
  const error = useRouteError();
  const { signOutReason } = useAuth();

  logger.error('Route error caught', {}, error);

  if (signOutReason === SignOutReason.Expired) {
    return null;
  }

  const title = isRouteErrorResponse(error)
    ? `${String(error.status)} — ${error.statusText}`
    : 'Something went wrong';

  const subtitle = isRouteErrorResponse(error)
    ? String(error.data)
    : 'An unexpected error occurred while loading this page.';

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{ minHeight: '100dvh', padding: '40px 20px' }}
    >
      <Result
        status="error"
        title={title}
        subTitle={
          <Paragraph>
            <Text>{subtitle}</Text>
            <br />
            <Text type="secondary">
              If this keeps happening please contact support.
            </Text>
          </Paragraph>
        }
        extra={
          <Flex gap={12} justify="center">
            <Button
              intent="secondary"
              onClick={() => {
                window.history.back();
              }}
            >
              Go Back
            </Button>
            <Button
              intent="primary"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Go Home
            </Button>
            <Button
              intent="secondary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload Page
            </Button>
          </Flex>
        }
      />
    </Flex>
  );
}
